import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../services/api.service';

/**
 * Envoi en exploitation d'une date (POST /vehicle-assignments/dispatch) et
 * son aperçu (GET /vehicle-assignments/dispatch/preview). Mêmes routes et
 * mêmes réponses que tms-chargeur.
 *
 * L'envoi passe les tournées brouillon des camions en tournées réelles
 * (visibles sur le web et le mobile) et verrouille les camions dans l'écran.
 * Un camion peut échouer sans retenir les autres : l'API répond alors 207,
 * avec son motif ; ses affectations restent modifiables.
 *
 * @returns {object} - { isDispatching, previewDispatch, dispatch }
 */
export default function useDispatchAssignments() {
  const [isDispatching, setIsDispatching] = useState(false);

  /**
   * @param {string} date - La date affichée (YYYY-MM-DD)
   * @returns {Promise<object|null>} - L'aperçu, ou null si l'échec a été affiché
   */
  const previewDispatch = useCallback(async (date) => {
    try {
      const response = await fleetApi.get(
        `/vehicle-assignments/dispatch/preview?date=${date}`
      );
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "L'aperçu de l'envoi n'a pas pu être chargé, veuillez réessayer."
      );
      return null;
    }
  }, []);

  /**
   * @param {string} date - La date affichée (YYYY-MM-DD)
   * @param {Array<string>} vehiculeKeys - Les camions à envoyer
   * @returns {Promise<object|null>} - { tours, failures, dispatched_at }, ou null si l'échec a été affiché
   */
  const dispatch = useCallback(async (date, vehiculeKeys) => {
    setIsDispatching(true);
    try {
      const response = await fleetApi.post('/vehicle-assignments/dispatch', {
        date,
        vehicule_keys: vehiculeKeys,
      });
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "L'envoi en exploitation n'a pas abouti, veuillez réessayer."
      );
      return null;
    } finally {
      setIsDispatching(false);
    }
  }, []);

  return { isDispatching, previewDispatch, dispatch };
}
